<template>
  <v-snackbar
    v-model="snackbar"
    :class="[
      { 'v-snack--left-position': mainMenuIsOpen && !noMainMenu },
      { 'v-snack--left-position-alt': !mainMenuIsOpen && !noMainMenu }
    ]"
    :color="props.color"
    :timeout="props.timeout"
    flat
    bottom
    left
  >
    <span v-if="props.message" v-html="props.message" />
    <v-btn flat fab @click="snackbar = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'Snackbar',
  computed: {
    ...mapState({
      props: state => state.snackbar,
      mainMenuIsOpen: state => state.mainMenu.isOpen
    }),

    snackbar: {
      set () {
        this.clearAlert()
      },

      get () {
        return this.props.isVisible
      }
    },

    noMainMenu () {
      return this.$route.meta.noMainMenu
    }
  },

  methods: {
    ...mapActions({
      clearAlert: 'snackbar/clear'
    })
  }
}
</script>

<style lang="scss">
.v-snack__content {
  height: auto;
  min-height: 48px;
  padding: 6px 24px;
}

.v-snack--left-position {

  @media (min-width: 1200px) {
    left: 256px;
  }
}

.v-snack--left-position-alt {

  @media (min-width: 1200px) {
    left: 73px;
  }
}

.v-snack__wrapper {
  box-shadow: none;
}
</style>
